// assets/hcc-product-custom-property.js
// cloned from product-custom-property and adjusted to allow for varying max lengths and javascript reload on
// variantUpdate
import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class HccProductCustomProperty extends Component {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  #onVariantUpdate( event ) {
    const newElement = event.detail.data.html.querySelector('hcc-product-custom-property-component div.js');
    const innerDiv = this.querySelector('div.js');
    if (innerDiv && newElement) {
      innerDiv.replaceWith(newElement);
    }
  }

  handleInput(event) {
    const line = event.target.dataset.line;
    this.#updateCharacterCount(line);
  }

  #updateCharacterCount(line) {
    const characterCount = this.refs[`characterCount_${line}`];
    const textInput = this.refs[`textInput_${line}`];
    const currentLength = textInput?.value.length;
    const maxLength = textInput?.maxLength;

    const template = characterCount?.getAttribute('data-template');
    if (!template) {
      return;
    }
    characterCount.textContent = template.replace('[current]', currentLength.toString())
      .replace('[max]', maxLength.toString());

  }
}

customElements.define('hcc-product-custom-property-component', HccProductCustomProperty);
